<div class=" container-fluid">
  <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
    <ol class="breadcrumb  shadow-lg">
      <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/dashboard">Dashboard administration</a></li>
      <li class="breadcrumb-item active" aria-current="page">Comptes business utilisateurs</li>
    </ol>
  </nav>

  <table class="row-border hover table-borderless table-striped" id="utilisateur">
    <thead>
      <tr>
        <th>ID</th>
        <th>First name</th>
        <th>Last name</th>
        <th>contact</th>
        <th>compte affaire</th>
        <th>Compte personel</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let person of persons" class="">
        <td>{{ person.id }}</td>
        <td>{{ person.firstName }}</td>
        <td>{{ person.lastName }}</td>
        <td>{{ person.phone }}</td>
        <td><button type="button" class="btn btn-outline-success"
            (click)="getAccountInformation(person.id,person.firstName,person.lastName)"><i
              class="bi bi-eye mr-2"></i></button></td>


        <td><button type="button" class="btn btn-outline-success"
            (click)="getAccountInformationprimaire(person.id,person.firstName,person.lastName)">
            <i class="bi bi-eye mr-2"></i></button></td>

      </tr>

    </tbody>
  </table>

</div>
